
import { Product } from "@/models/base";
import Vue from "vue";
import AppLabel from "@/components/common/InfoInput.vue";

export default Vue.extend({
	props: {
		product: {
			type: Object as ()=>Product,
			required: true
		}
	},
	components: {
		AppLabel
	},
	i18nEx: {
		componentPrefix: "components.products"
	}
});
